import { Text, TextHighlight, TextSize } from '@focaldata/cin-ui-components'
import React from 'react'

interface Props {
  details: string
}

const LaunchErrorDetails: React.FC<Props> = ({ details }) => (
  <details style={{ overflowWrap: 'anywhere' }}>
    <summary style={{ cursor: 'pointer' }}>Show details</summary>
    <Text size={TextSize.ms} highlight={TextHighlight.Error} multiline>
      {details}
    </Text>
  </details>
)

export default LaunchErrorDetails
